<template>
    <div id="summary">
        <div class="app-container mt-5 mb-5">
            <div class="d-flex justify-content-between mb-5">
                <div class="d-flex" v-if="!$global.loading">
                    <div class="category-btn mr-3">
                        {{ provider.last_version.category.label }}
                    </div>

                    <div class="page-title mr-3">
                        {{ provider.last_version.name }}
                    </div>

                    <div v-if="provider.apidae_source !== null">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon target="_blank" :href="provider.apidae_source.url">
                                    <v-icon>open_in_new</v-icon>
                                </v-btn>
                            </template>
                            <span>Voir sur Apidae</span>
                        </v-tooltip>
                    </div>
                </div>

                <div class="d-flex justify-content-between">
                    <div v-if="account.tis_type.code === 'DAHUB_QUEBEC'">
                        <v-btn outlined class="custom-button-primary mr-5" :to="openFormUrl" target="_blank">
                            <v-icon left>open_in_new</v-icon> Voir le formulaire
                        </v-btn>
                    </div>

                    <div v-if="!vtContract">
                        <v-btn outlined class="custom-button-primary" @click="setOpenModal"
                               :disabled="this.tabulations.length === 0">
                            <v-icon left>send</v-icon> Envoyer une demande d'informations individuelle
                        </v-btn>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-4">
                    <div class="gap-15 d-flex flex-column" id="fixed">
                        <contact-bloc :contact="contact" :providerId="providerId"
                                      :providerSelectionsCount="belongsToSelection" :provider="provider">
                        </contact-bloc>
                        <referent-bloc :referent="referent" :provider-id="providerId"></referent-bloc>
                        <tag-bloc :provider-id="providerId"></tag-bloc>
                        <note-bloc :provider-id="providerId"></note-bloc>
                        <selection-bloc :provider-id="providerId" v-if="account.tis_type.code === 'APIDAE'">
                        </selection-bloc>
                        <last-sync-bloc :last-sync-date="provider.last_sync_date" v-if="account.tis_type.code === 'DAHUB_QUEBEC'"></last-sync-bloc>
                    </div>
                </div>
                <div class="col-8 gap-15 d-flex flex-column">
                    <campaign-bloc :provider-id="providerId" v-if="!vtContract"></campaign-bloc>
                    <comment-and-phone-bloc :provider-id="providerId"></comment-and-phone-bloc>
                    <history-bloc :actions="actions" :provider="provider"></history-bloc>
                </div>
            </div>
        </div>

        <create-unique-form-modal ref="modale"></create-unique-form-modal>
        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import CreateUniqueFormModal from "../../campaign/cmaj/CreateUniqueFormModal"
import { mapMutations, mapState } from "vuex"
import Confirm from "../../tools/Confirm"
import NoteBloc from "./NoteBloc"
import CommentAndPhoneBloc from "./CommentAndPhoneBloc"
import HistoryBloc from "./HistoryBloc"
import TagBloc from "./TagBloc"
import CampaignBloc from "./CampaignBloc"
import ContactBloc from "./ContactBloc"
import ReferentBloc from "./ReferentBloc"
import SelectionBloc from "./SelectionBloc.vue";
import LastSyncBloc from "./LastSyncBloc.vue"
export default {
    name: "Summary",
    components: {
        LastSyncBloc,
        ReferentBloc,
        ContactBloc,
        CampaignBloc, TagBloc, HistoryBloc, CommentAndPhoneBloc, NoteBloc, Confirm, CreateUniqueFormModal, SelectionBloc
    },
    data() {
        return {
            providerId: null,
            provider: { last_version: {} },
            actions: [],
            contact: { profession: null },
            tabulations: [],
            isLg: true,
            referent: null,
            belongsToSelection: false,
            openFormUrl: null
        }
    },
    methods: {
        ...mapMutations('createCmaj', ['resetState', 'setCurrentStep']),
        getProvider() {
            this.$global.loading = true

            this.$http.get('auth/providers/' + this.providerId).then(res => {
                this.provider = res.body.data.provider
                this.contact = res.body.data.provider.contact
                this.referent = this.provider.referent
                this.belongsToSelection = res.body.data.belongsToSelection

                this.getFields(this.provider.last_version.category.name)

                this.$global.loading = false
            })
        },
        getFields(categoryName) {
            this.$http.get('auth/account/referential/category-fields/' + categoryName).then(res => {
                this.tabulations = res.body.data.fields
            })
        },
        getActions() {
            this.$http.get('auth/providers/' + this.providerId + '/actions').then(res => {
                this.actions = res.body.data.actions
            })
        },
        setOpenModal() {
            this.setCurrentStep(1)

            this.$refs.modale.open(this.tabulations, this.contact, this.provider)
        },
        findBootstrapEnvironment() {
            let envs = ['xs', 'sm', 'md', 'lg', 'xl']

            let el = document.createElement('div')
            document.body.appendChild(el)

            let curEnv = envs.shift()

            for (let env of envs.reverse()) {
                el.classList.add(`d-${env}-none`)

                if (window.getComputedStyle(el).display === 'none') {
                    curEnv = env
                    break
                }
            }

            document.body.removeChild(el)

            this.isLg = ['lg', 'xl'].includes(curEnv)
        },
    },
    computed: {
        ...mapState('account', ['user', 'account', 'vtContract'])
    },
    created() {
        let hash = this.$route.params.hash
        this.providerId = parseInt(atob(hash))

        this.getProvider()
        this.getActions()

        this.findBootstrapEnvironment()

        window.addEventListener("resize", this.findBootstrapEnvironment)

        this.$global.$on('reload-summary', () => {
            this.getProvider()
            this.getActions()

            this.$refs.modale.cancel()
        })

        this.openFormUrl = '/espace-pro/formulaire/' + this.providerId
    },
    beforeDestroy() {
        this.$global.$off('reload-summary')

        window.removeEventListener("resize", this.findBootstrapEnvironment)
    }
}
</script>